module.exports = __webpack_public_path__ + "img/icon-figma.9b150171.png";